import { render, staticRenderFns } from "./scientific-analysis-filter-panel-patientage.vue?vue&type=template&id=32d39926&scoped=true&"
import script from "./scientific-analysis-filter-panel-patientage.ts?vue&type=script&lang=ts&"
export * from "./scientific-analysis-filter-panel-patientage.ts?vue&type=script&lang=ts&"
import style0 from "./scientific-analysis-filter-panel-patientage.scss?vue&type=style&index=0&id=32d39926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d39926",
  null
  
)

export default component.exports